import { FaBell, FaBolt, FaBox, FaHistory, FaLink, FaSearch, FaStar, FaTasks, FaThLarge, FaTools } from "react-icons/fa";
import { CenterViewMain } from "../Components/CenterViewMain";

const route = (path, mode, label, icon) => ({
    views: "PRIVATE", path, component: <CenterViewMain mode={mode} />,
    roles: null, permissions: null, label, icon,
    displayInHeader: false, displayInFooter: false, displayInSidebar: false,
    isBlockedWhenLogged: false,
});

export const CenterModule = () => [
    route("/today", "today", "Hoy", <FaBolt />),
    route("/search", "search", "Buscar", <FaSearch />),
    route("/inbox", "inbox", "Inbox", <FaBox />),
    route("/reminders", "reminders", "Recordatorios", <FaBell />),
    route("/favorites", "favorites", "Favoritos", <FaStar />),
    route("/activity", "activity", "Actividad", <FaHistory />),
    route("/relations", "relations", "Relaciones", <FaLink />),
    route("/versions", "versions", "Versiones", <FaHistory />),
    route("/templates", "templates", "Plantillas", <FaThLarge />),
    route("/runbooks", "runbooks", "Runbooks", <FaTasks />),
    route("/backup", "backup", "Backup", <FaTools />),
];
